import Dashboard from '@/components/layout/Dashboard';
import DemoForm from '@/pages/DemoForm';
import Home from '@/pages/Home';
import Import from '@/pages/Import';
import Payee from '@/pages/Payee';
import Settings from '@/pages/Settings';

import InternalMessages from '@/pages/messages/InternalMessages';
import Messages from '@/pages/messages/Messages';
import HomeBanners from '@/pages/messages/HomeBanners';
import News from '@/pages/messages/News';
import Notifications from '@/pages/messages/Notifications';
import Posts from '@/pages/messages/Posts';

import BillsImport from '@/pages/import/BillsImport';

import AccountingSettings from '@/pages/settings/AccountingSettings';
import BillSettings from '@/pages/settings/BillSettings';
import CurrenciesProperties from '@/pages/settings/CurrenciesProperties';
import NotificationSettings from '@/pages/settings/Notifications';
import OrganizationInfo from '@/pages/settings/OrganizationInfo';
import PayersSettings from '@/pages/settings/PayersSettings';
import PaymentsSettings from '@/pages/settings/PaymentsSettings';
import Settlements from '@/pages/settings/Settlements';
import ShopSettings from '@/pages/settings/ShopSettings';
import MobileAppSettings from '@/pages/settings/MobileAppSettings';

import ArchivedPayers from '@/pages/ArchivedPayers';
import Payers from '@/pages/Payers';
import BillForm from '@/pages/bills/BillForm';
import BankStatements from '@/pages/payments/BankStatements';
import PaymentForm from '@/pages/payments/PaymentForm';
import Payments from '@/pages/payments/Payments';

import BillingDocuments from '@/pages/bills/BillingDocuments';
import BillingDocumentsForm from '@/pages/bills/BillingDocumentsForm';
import BillingPlans from '@/pages/bills/BillingPlans';
import Bills from '@/pages/bills/Bills';
import FormConfiguration from '@/pages/forms/FormConfiguration';
import ImportPayers from '@/pages/import/ImportPayers';
import ImportTimetable from '@/pages/import/ImportTimetable';
import BalanceReport from '@/pages/reports/BalanceReport';
import FormsSettings from '@/pages/settings/FormsSettings';
import AccessManagement from '@/pages/settings/access/AccessManagement';

import AvailabilityForm from '@/pages/shop/AvailabilityForm';
import AvailabilityImport from '@/pages/shop/AvailabilityImport';
import CatalogIndex from '@/pages/shop/CatalogIndex';
import DeliveryCalendar from '@/pages/shop/DeliveryCalendar';
import ProductSetsV1 from '@/pages/shop/ProductSetsV1';
import Subscriptions from '@/pages/shop/Subscriptions';
import OrderForm from '@/pages/shop/order/OrderForm';
import SubscriptionForm from '@/pages/shop/order/SubscriptionForm';
import SubscriptionMoveForm from '@/pages/shop/order/SubscriptionMoveForm';

import CatalogSettings from '@/pages/shop/CatalogSettings';
import Orders from '@/pages/shop/Orders';
import Products from '@/pages/shop/Products';
import Reports from '@/pages/shop/Reports';
import ShopCatalogsIndex from '@/pages/shop/ShopCatalogsIndex';
import ArchivedCatalogs from '@/pages/shop/catalogs/ArchivedCatalogs';
import CatalogOffer from '@/pages/shop/catalogs/CatalogOffer';
import PayersVindication from '@/pages/payers/PayersVindication';
import PayersIndex from '@/pages/payers/PayersIndex';
import Results from '@/pages/shop/Results';

export default {
  path: '',
  component: Dashboard,
  children: [
    {
      path: '',
      component: Home,
    },
    {
      path: '/tenant/add',
      component: DemoForm,
    },
    {
      path: '/payee/:payeeId?',
      component: Payee,
      props: true,
      children: [
        {
          path: 'payers',
          component: Payers,
          children: [
            {
              path: '',
              component: PayersIndex,
            },
            {
              path: 'vindication',
              component: PayersVindication,
            },
          ],
        },
        {
          path: 'payers/archived',
          component: ArchivedPayers,
        },
        {
          path: 'import',
          component: Import,
          children: [
            {
              path: 'payers',
              component: ImportPayers,
            },
            {
              path: 'timetable',
              component: ImportTimetable,
            },
          ],
        },
        {
          path: 'shop/catalogs',
          component: ShopCatalogsIndex,
        },
        {
          path: 'shop/catalogs/archived',
          component: ArchivedCatalogs,
        },
        {
          path: 'shop',
          redirect: 'shop/catalogs',
        },
        {
          path: 'shop/:catalogId/settings',
          component: CatalogSettings,
          props: true,
          children: [
          ],
        },
        {
          path: 'shop/:catalogId',
          component: CatalogIndex,
          props: true,
          children: [
            {
              path: 'orders',
              component: Orders,
              props: true,
            },
            {
              path: 'offer',
              component: CatalogOffer,
              props: true,
            },
            {
              path: 'products',
              component: Products,
              props: true,
            },
            {
              path: 'sets_v1',
              component: ProductSetsV1,
              props: true,
            },
            {
              path: 'calendar',
              component: DeliveryCalendar,
              props: true,
            },
            {
              path: 'reports',
              component: Reports,
              props: true,
            },
            {
              path: 'subscriptions',
              component: Subscriptions,
              props: true,
            },
            {
              path: 'results',
              component: Results,
              props: true,
            },
          ],
        },
        {
          path: 'shop/:catalogId/order',
          component: OrderForm,
          props: true,
        },
        {
          path: 'shop/:catalogId/subscription',
          component: SubscriptionForm,
          props: true,
        },
        {
          path: 'shop/:catalogId/subscription/move',
          component: SubscriptionMoveForm,
          props: true,
        },
        {
          path: 'shop/:catalogId/availability',
          component: AvailabilityForm,
          props: true,
        },
        {
          path: 'shop/:catalogId/import',
          component: AvailabilityImport,
          props: true,
        },
        {
          path: 'payments',
          component: Payments,
        },
        {
          path: 'payments/bank-statements',
          component: BankStatements,
        },
        {
          path: 'bills/import',
          component: BillsImport,
        },
        {
          path: 'bills/form',
          component: BillForm,
        },
        {
          path: 'payments/form',
          component: PaymentForm,
        },
        {
          path: 'bills',
          component: Bills,
        },
        {
          path: 'bills/plans',
          component: BillingPlans,
        },
        {
          path: 'bills/documents',
          component: BillingDocuments,
        },
        {
          path: 'bills/documents/form',
          component: BillingDocumentsForm,
        },
        {
          path: 'reports/balance',
          component: BalanceReport,
        },
        // {
        //   path: 'reports/settlement',
        //   component: SettlementReport,
        // },
        {
          path: 'reports',
          redirect: 'reports/balance',
        },
        {
          path: 'messages',
          component: Messages,
          children: [
            {
              path: 'messages',
              component: InternalMessages,
            },
            {
              path: 'notifications',
              component: Notifications,
            },
            {
              path: 'posts',
              component: Posts,
            },
            {
              path: 'banners',
              component: HomeBanners,
            },
            {
              path: 'news/:postId?',
              component: News,
              props: true,
            },
            {
              path: '',
              redirect: 'messages',
            },
          ],
        },
        {
          path: 'settings/form/:id',
          component: FormConfiguration,
          props: true,
        },
        {
          path: 'settings',
          component: Settings,
          children: [
            {
              path: 'info',
              component: OrganizationInfo,
            },
            {
              path: 'currencies',
              component: CurrenciesProperties,
            },
            {
              path: 'payers',
              component: PayersSettings,
            },
            {
              path: 'shop',
              component: ShopSettings,
            },
            {
              path: 'bills',
              component: BillSettings,
            },
            {
              path: 'payments',
              component: PaymentsSettings,
            },
            {
              path: 'accounting',
              component: AccountingSettings,
            },
            {
              path: 'notifications',
              component: NotificationSettings,
            },
            {
              path: 'settlements',
              component: Settlements,
            },
            {
              path: 'forms',
              component: FormsSettings,
            },
            {
              path: 'access',
              component: AccessManagement,
            },
            {
              path: 'mobile-app',
              component: MobileAppSettings,
            },
            {
              path: '',
              redirect: 'payers',
            },
          ],
        },
      ],
    },
  ],
};
